<script setup lang="ts">
import { useHeaderProps } from '@/common/customisation/composables';
import { useHelpBodyBackgroundCustomisation } from './composables/useHelpBodyCustomisation';
import {
  useHelpHeaderCustomisation,
  useHelpHeaderSearchCustomisation,
  useHelpHeaderTitleCustomisation,
  useHelpNavIcon1Customisation,
  useHelpNavIcon2Customisation,
} from './composables/useHelpHeaderCustomisation';

import GenericHeader from '@/components/GenericHeader.vue';
import SelfService from './SelfService.vue';
import FAQs from './FAQs.vue';

const { contentStyle } = useHelpBodyBackgroundCustomisation();

const headerCustomisation = useHelpHeaderCustomisation();
const titleCustomisation = useHelpHeaderTitleCustomisation();
const navIcon1Customisation = useHelpNavIcon1Customisation();
const navIcon2Customisation = useHelpNavIcon2Customisation();
const searchCustomisation = useHelpHeaderSearchCustomisation();

const { headerProps } = useHeaderProps({
  header: headerCustomisation,
  title: titleCustomisation,
  navIcon1: navIcon1Customisation,
  navIcon2: navIcon2Customisation,
  search: searchCustomisation,
});
</script>

<template>
  <div class="page-container">
    <GenericHeader
      :header="headerProps.header"
      :title="headerProps.title"
      :search="headerProps.search"
      :nav-icon1="headerProps.navIcon1"
      :nav-icon2="headerProps.navIcon2"
    />

    <!-- Content Container - Scrollable -->
    <div class="content-container page-content" :style="contentStyle">
      <!-- Self Service Section -->
      <SelfService />

      <!-- FAQs Section -->
      <!-- COMMENTING FOR NOW, THIS WILL ENHANCED IN NEXT ITERATIONS -->
      <!-- <FAQs /> -->
    </div>
  </div>
</template>

<style scoped lang="scss">
.content-container {
  padding-bottom: 100px;
}
</style>
